(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["found-it-exact-header"] && !Shopify.designMode) return;
  try {
    
  function initFoundItZineMenu(root) {
    if (root.dataset.fiZineReady === 'true') return;
    root.dataset.fiZineReady = 'true';
    const mobile = root.querySelector('.fi-zine-header__mobile');
    const openButton = root.querySelector('[data-fi-menu-open]');
    const drawer = root.querySelector('[data-fi-menu-drawer]');
    const closeButtons = root.querySelectorAll('[data-fi-menu-close]');
    if (!mobile || !openButton || !drawer) return;
    const setOpen = (open) => {
      mobile.classList.toggle('is-open', open);
      openButton.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('aria-hidden', String(!open));
      document.documentElement.classList.toggle('fi-zine-menu-open', open);
      if (open) drawer.querySelector('[data-fi-menu-close]').focus();
      else openButton.focus();
    };
    openButton.addEventListener('click', () => setOpen(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobile.classList.contains('is-open')) setOpen(false);
    });
  }
  document.querySelectorAll('[data-fi-zine-menu]').forEach(initFoundItZineMenu);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-fi-zine-menu]').forEach(initFoundItZineMenu));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
